import React from 'react'

const CheckboxInput = React.forwardRef((props, ref) => (
  <input type='checkbox' className='filters-control' {...props} ref={ref} />
))

export default CheckboxInput
